import { EnvironmentVariable } from '@/constants';
import { LabourWorkload } from '../types/labourWorkLoad';
import { Periodicity } from '../types/periodicity';

type BuildTaskFormDataProps = {
  name: string;
  businessAreaId: number;
  description: string | undefined;
  periodicity: Periodicity;
  workload: number;
  workflowId: number | undefined;
  labourWorkloadType: LabourWorkload;
  averageCases: number | undefined;
};

export const buildTaskFormData = ({
  name,
  businessAreaId,
  description,
  periodicity,
  workload,
  workflowId,
  labourWorkloadType,
  averageCases,
}: BuildTaskFormDataProps) => {
  const taskFormData = new FormData();
  taskFormData.append('name', name);
  taskFormData.append('businessAreaId', businessAreaId.toString());
  description && taskFormData.append('description', description);
  taskFormData.append('periodicityId', periodicity.toString());

  /* 
    The environment checking condition, was due an issue when running locally
    the workload value should be sent with "," as decimal separator, but for
    QA and Production should be sent with ".". Issue with machine locale.
    
    Original Bug: https://app.clickup.com/t/8696mqvpb 
    Fix: https://bitbucket.org/inspireitadmin/automationsphere.react/pull-requests/322/diff

    Reported Prod issue with decimal places: https://app.clickup.com/t/869a26nuh
  */
  taskFormData.append(
    'workload',
    EnvironmentVariable.MODE == 'development'
      ? workload.toString().replace('.', ',')
      : workload.toString(),
  );

  workflowId && taskFormData.append('workflowId', workflowId.toString());
  taskFormData.append('workloadTypeId', labourWorkloadType.toString());
  averageCases && taskFormData.append('averageCases', averageCases.toString());

  return taskFormData;
};
